module.exports = __webpack_public_path__ + "img/acidification-terrestrial.3b68b955.svg";